import { trackPromise } from 'react-promise-tracker';
import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import api from './api';
import Axios from 'axios';

export interface AbaGovernancaAprovacao {
  id?: string;
  demandaId?: string;
  ordemCompraId?: string;
  requisicaoCompraId?: string;
  identificador?: string;
  statusGovernancaAprovacaoTexto?: string;
  statusGovernancaAprovacaoCodigo?: number;
  responsavelGpc?: string;
  expectativaValorFinal?: number;
  cciRegraDefinida?: string;
  cciResumo?: string;
  cciPontuacao?: number;
  temPrevisaoOrcamentaria?: boolean;
  isFornecedorDirecionado?: boolean;
  cciClausulaSaidaId?: string;
  cciConflitoInteresseId?: string;
  cciEscopoId?: string;
  cciDirecionamentoId?: string;
}

export interface AtributoCci {
  id: string;
  atributo: string;
  definicao: string;
  pontos: number;
}

export const getDadosGovernanca = (id: string) => api.get(`governancaAprovacao/GetDados/${id}`);
export const getAtributosCci = () => api.get<AtributoCci[]>(`governancaAprovacao/GetAtributosCci`);
export const getAtributosCciOptions = (atributo: string) => {
  return getAtributosCci().then(data => {
    let filtered = data.filter(at => at.atributo == atributo).sort((a, b) => a.pontos - b.pontos);
    return filtered.map(a => ({ text: a.definicao, value: a.id.toString() }));
  });
};
export const updateGovernanca = (values: any) => api.put(`governancaAprovacao`, values);
export const avancarGovernanca = (id: string) => api.put(`governancaAprovacao/avancar/${id}`);
export const aprovarGovernanca = (id: string) => api.put(`governancaAprovacao/aprovar/${id}`);
export const reprovarGovernanca = (id: string) => api.put(`governancaAprovacao/reprovar/${id}`);
export const incluirAnexoGovernanca = (values: any) => {
  const form = new FormData();
  Object.keys(values).forEach(key => {
    form.append(key, values[key]);
  });
  return api.post<any>(`governancaAprovacao/incluirAnexo`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const viewAnexoGovernanca = async (id: string, nome: string) => {
  const url = window.location.origin + `/api/governancaAprovacao/DownloadAnexo/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nome);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) window.open(fileUrl);
  });
};
export const downloadAnexoGovernanca = (id: string, nome: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/governancaAprovacao/DownloadAnexo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};
